import { Link } from 'react-router-dom';

const footerLinks = {
  produto: [
    { label: 'Como funciona', href: '#como-funciona', external: false },
    { label: 'Estilos musicais', href: '#estilos', external: false },
    { label: 'Ocasiões', href: '#ocasioes', external: false },
    { label: 'Preço', href: '#preco', external: false },
    { label: 'Blog', href: '/blog', external: true },
    { label: 'Programa de Afiliados', href: '/afiliados', external: true },
    { label: 'Portal do Afiliado', href: '/afiliados/portal', external: true },
  ],
  suporte: [
    { label: 'Perguntas frequentes', href: '#faq', external: false },
    { label: 'Garantia', href: '#garantia', external: false },
    { label: 'Fale conosco', href: '#', external: false },
    { label: 'Termos de Serviço', href: '/termos-de-servico', external: true },
    { label: 'Política de privacidade', href: '/politica-de-privacidade', external: true },
    { label: 'Exclusão de dados', href: '/exclusao-de-dados', external: true },
  ],
};

export default function Footer() {
  const scrollTo = (href: string) => {
    if (href === '#') return;
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer style={{ background: 'var(--footer-bg)' }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <img
              src="/logo-dark.png"
              alt="Inspira Músicas"
              style={{ width: 110, height: 110, objectFit: 'contain', marginBottom: 16 }}
            />
            <p
              className="text-sm leading-relaxed max-w-xs"
              style={{ color: 'rgba(255,255,255,0.40)', fontFamily: "'DM Sans', sans-serif", fontWeight: 300 }}
            >
              Músicas personalizadas para eternizar os momentos mais especiais da sua vida.
              Entregues por e-mail em até 30 minutos.
            </p>
            <div className="flex gap-3 mt-5">
              {[
                { icon: 'ri-instagram-line', href: '#' },
                { icon: 'ri-whatsapp-line', href: '#' },
                { icon: 'ri-youtube-line', href: '#' },
                { icon: 'ri-tiktok-line', href: '#' },
              ].map((social) => (
                <a
                  key={social.icon}
                  href={social.href}
                  rel="nofollow"
                  className="w-8 h-8 flex items-center justify-center rounded-full cursor-pointer transition-all duration-200"
                  style={{ background: 'rgba(255,255,255,0.08)' }}
                  onMouseEnter={(e) => {
                    (e.currentTarget as HTMLAnchorElement).style.background = 'var(--gold)';
                  }}
                  onMouseLeave={(e) => {
                    (e.currentTarget as HTMLAnchorElement).style.background = 'rgba(255,255,255,0.08)';
                  }}
                >
                  <i className={`${social.icon} text-sm`} style={{ color: 'rgba(255,255,255,0.50)' }} />
                </a>
              ))}
            </div>
          </div>

          {/* Links: Produto */}
          <div>
            <h4
              className="text-xs font-bold uppercase tracking-widest mb-4"
              style={{ color: 'rgba(255,255,255,0.30)', fontFamily: "'DM Sans', sans-serif" }}
            >
              Produto
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.produto.map((link) => (
                <li key={link.label}>
                  {link.external ? (
                    <Link
                      to={link.href}
                      className="text-sm cursor-pointer transition-colors duration-200"
                      style={{ color: 'rgba(255,255,255,0.45)', fontFamily: "'DM Sans', sans-serif" }}
                      onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--gold)')}
                      onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(255,255,255,0.45)')}
                    >
                      {link.label}
                    </Link>
                  ) : (
                    <a
                      href={link.href}
                      rel="nofollow"
                      onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                      className="text-sm cursor-pointer transition-colors duration-200"
                      style={{ color: 'rgba(255,255,255,0.45)', fontFamily: "'DM Sans', sans-serif" }}
                      onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--gold)')}
                      onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(255,255,255,0.45)')}
                    >
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Links: Suporte */}
          <div>
            <h4
              className="text-xs font-bold uppercase tracking-widest mb-4"
              style={{ color: 'rgba(255,255,255,0.30)', fontFamily: "'DM Sans', sans-serif" }}
            >
              Suporte
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.suporte.map((link) => (
                <li key={link.label}>
                  {link.external ? (
                    <Link
                      to={link.href}
                      className="text-sm cursor-pointer transition-colors duration-200"
                      style={{ color: 'rgba(255,255,255,0.45)', fontFamily: "'DM Sans', sans-serif" }}
                      onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--gold)')}
                      onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(255,255,255,0.45)')}
                    >
                      {link.label}
                    </Link>
                  ) : (
                    <a
                      href={link.href}
                      rel="nofollow"
                      onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                      className="text-sm cursor-pointer transition-colors duration-200"
                      style={{ color: 'rgba(255,255,255,0.45)', fontFamily: "'DM Sans', sans-serif" }}
                      onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--gold)')}
                      onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(255,255,255,0.45)')}
                    >
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div
          className="pt-8 flex flex-col sm:flex-row justify-between items-center gap-4"
          style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}
        >
          <p
            className="text-xs"
            style={{ color: 'rgba(255,255,255,0.25)', fontFamily: "'DM Sans', sans-serif" }}
          >
            &copy; {new Date().getFullYear()} Inspira Músicas. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-2">
            <i className="ri-lock-line text-xs" style={{ color: 'var(--gold)' }} />
            <span
              className="text-xs"
              style={{ color: 'rgba(255,255,255,0.25)', fontFamily: "'DM Sans', sans-serif" }}
            >
              Pagamento 100% seguro · Entrega por e-mail
            </span>
          </div>
        </div>

        {/* Razão social — exigência legal + verificação Meta/Facebook Business */}
        <p
          className="text-center text-xs mt-6 leading-relaxed"
          style={{ color: 'rgba(255,255,255,0.32)', fontFamily: "'DM Sans', sans-serif" }}
        >
          AUTOMAT TECNOLOGIA DA INFORMAÇÃO LTDA · CNPJ 59.640.197/0001-76
          <br />
          Rua Pais Leme, 215, Conj. 1713, Sala 01, Andar 16 — Pinheiros, São Paulo/SP — CEP 05424-150
        </p>
      </div>
    </footer>
  );
}
